// extracted by mini-css-extract-plugin
module.exports = {"itemForm":"ItemForm_itemForm__21Sl5","section":"ItemForm_section__3GQb3"};